import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { __ } from '@web/birdz-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-column-help-kpi',
  imports: [MatIconModule, TranslocoPipe],
  templateUrl: './column-help-kpi.component.html',
  styleUrl: './column-help-kpi.component.scss',
})
export class ColumnHelpKpiComponent {
  okLabel = '';
  koLabel = '';
  excludedLabel = '';
  isRaw = false;

  constructor() {}

  agInit(params: ICellRendererParams & { techno: string; isRaw?: boolean }) {
    this.isRaw = params.isRaw ?? false;
    if (params.techno === 'watermetering') {
      this.okLabel = __('KPI_OK.HELP.WATER');
      this.koLabel = __('KPI_KO.HELP.WATER');
      this.excludedLabel = __('KPI_EXCLUDED.HELP.WATER');
    } else if (params.techno === 'sewerin') {
      this.okLabel = __('KPI_OK.HELP.SEWERIN');
      this.koLabel = __('KPI_KO.HELP.SEWERIN');
      this.excludedLabel = __('KPI_EXCLUDED.HELP.SEWERIN');
    }
  }

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }
}
